import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { HoverLimitMessage } from "./HoverLimitMessage";
import styles from "./HoverLimit.module.scss";
export const HoverLimit = ({ productLimitCurrency, productLimit, displayStatus }) => {
    const className = classNames({
        [styles.container]: true,
        [styles.show]: displayStatus,
    });
    return (_jsx("span", { className: className, children: _jsx(HoverLimitMessage, { productLimitCurrency: productLimitCurrency, productLimit: productLimit }) }));
};
//# sourceMappingURL=HoverLimit.js.map